import { MaxWinConfig } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/paytableContentFactory/AbstractPaytableContentFactory";

type Rtp = number;

type RtpConfig = Record<Rtp, MaxWinConfig>;

export const maxWinConfigs: RtpConfig = {
    88: {//TODO rtp is not currently sent from server
        minRatio: 1,
        maxRatio: 1000000000
    }
};